import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuizQuestionType } from '@edtech-ui/constants/quiz-question-type.enum';

@Component({
	selector: 'app-question-type',
	standalone: true,
	imports: [FormsModule, CommonModule],
	templateUrl: './question-type.component.html',
	styleUrl: './question-type.component.scss'
})
export class QuestionTypeComponent {
	
	@Input() selected!:QuizQuestionType;
	@Output() selectedChange = new EventEmitter<QuizQuestionType>();
	_QuizQuestionType = QuizQuestionType;

	setType(type: QuizQuestionType) {
		this.selected = type;
		this.selectedChange.emit(type);
	}

}